const TEXT = {
    INVITE_BRAND_TEXT_1:"邀请新代理",
    INVITE_BRAND_TEXT_2:"确认",
    INVITE_BRAND_TEXT_3:"选择品牌",
    INVITE_BRAND_TEXT_4:"确认",
};
export {
	TEXT
}



// WEBPACK FOOTER //
// ./src/config/page/cn/invite/brand/index.js